import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahServiceItems } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { SahServiceItem } from '~lookups/models';

export const typePrefix = 'sah-service-items';

export const sahServiceItemsApi = createApi({
  reducerPath: 'sahServiceItemsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahServiceItems }),
  tagTypes: ['sah-service-items'],
  endpoints: (builder) => ({
    getSahServiceItems: builder.query<SahServiceItem[], Request | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'sah-service-items', id: 'LIST' }],
      transformResponse: (payload) => unwrap<SahServiceItem[]>(payload),
    }),
  }),
});

export const { useGetSahServiceItemsQuery } = sahServiceItemsApi;
